import { ViewportScroller } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, ActivatedRoute } from '@angular/router';
import { PaginationService } from 'src/app/PaginationService';
import { AppService } from 'src/app/app.service';
import { messageService } from 'src/app/message.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { MatRadioChange } from '@angular/material/radio';
import { MsalService } from '@azure/msal-angular';
import { DocViewerConfig } from 'src/app/support/models/doc-viewer-config.model';
import { DocumentViewerPrinterComponent } from 'src/app/support/document-viewer-printer/document-viewer-printer.component';
import { DocumentViewerComponent } from 'src/app/support/document-viewer/document-viewer.component';
import { forkJoin, lastValueFrom, Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-document-download',
  templateUrl: './document-download.component.html',
  styleUrls: ['./document-download.component.scss']
})
export class DocumentDownloadComponent implements OnInit {

  @Output() valueChange = new EventEmitter<boolean>;
  @Input() documentData: any;
  @Input() isFrom: any;
  @Input() file: File;
  @Input() selectedDocList: any = [];
  @Input() isPrintMode: boolean = false;
  @Input() isOnlyPreviewMode: boolean = false;
  listOfDmsIssuanceTypes: any = [];
  title: any;
  isProcessing = false;
  issuanceCopyInvalid: boolean = false;
  constructor(private readonly _formBuilder: FormBuilder, public appService: AppService, private readonly router: Router, public dialog: MatDialog,
    private readonly scroller: ViewportScroller, private readonly snackBar: MatSnackBar, private readonly activatedRoute: ActivatedRoute,
    private readonly message: messageService, public paginationService: PaginationService, private readonly authService: MsalService) {

  }
  docViewer!: DocViewerConfig;
  @ViewChild('viewPopup2', { static: false }) documentViewerPrinterComponent?: DocumentViewerPrinterComponent;
  @ViewChild('viewPopup') documentViewerComponent?: DocumentViewerComponent;



  folderId = 0;
  dropdownForHeaderReportTemplate: any = [];
  documentTypeData: any = {};
  showPreviewButton: boolean = false;
  documentTypesList: any = [];
  downloadTemplatesList: any = [];
  selectedDownloadTemplate: any;
  downloadTemplateDropdown: any[] = [];


  ngOnInit() {
    this.showPreviewButton = this.isFrom != 'BULK';

    if (this.documentData || (this.isFrom === 'BULK' && this.selectedDocList?.length > 0)) {
      this.loadIssuanceTypes();
    }
    const docTypeList$ = this.appService.getDocumentTypeListFromOneQmsDocumentTypesVw();
    const allTemplates$ = this.appService.getAllDownloadTemplates();

    this.isProcessing = true;

    forkJoin([docTypeList$, allTemplates$]).subscribe({
      next: ([docTypes, templates]: [any[], any[]]) => {
        this.documentTypesList = docTypes;
        this.downloadTemplatesList = templates;

        this.downloadTemplateDropdown = templates.map(t => ({
          valueExp: t.templateId,
          displayExp: t.templateName
        }));
        if (this.isFrom !== 'BULK' && this.documentData?.documentTypeCode) {

          console.log("Auto-Select: Checking for DocType:", this.documentData.documentTypeCode);

          // Find config for this document type
          const matchingDocTypeConfig = this.documentTypesList.find(
            (type: any) => type.documentTypeCode === this.documentData.documentTypeCode
          );

          if (matchingDocTypeConfig?.downloadTemplateId) {
            console.log("Auto-Select: Found Config. Target Template ID:", matchingDocTypeConfig.downloadTemplateId);

            // Find the template (Using '==' to handle string/number mismatches safely)
            const matchingTemplate = this.downloadTemplatesList.find(
              (temp: any) => temp.templateId == matchingDocTypeConfig.downloadTemplateId
            );

            if (matchingTemplate) {
              console.log("Auto-Select: Found Matching Template:", matchingTemplate.templateName);

              this.selectedDownloadTemplate = matchingTemplate.templateId;

              this.selectedOptionforDownload = 'Issue Document';

              this.populateFormWithTemplateData(matchingTemplate);

              this.loadIssuanceTypes();
            } else {
              console.warn("Auto-Select: Template ID found in config but not in template list.");
            }
          } else {
            console.log("Auto-Select: No downloadTemplateId configured for this Document Type.");
          }
        }
        this.isProcessing = false;
      },
      error: (err) => {
        console.error("Error fetching dependencies:", err);
        this.isProcessing = false;
      }
    });
    if (this.isFrom == "BULK") {
      this.folderId = this.selectedDocList[0].folderId;
    } else {
      this.folderId = this.documentData.folderId;
      this.appService.getDocumentTypeByCode(this.documentData.documentTypeCode)
        .subscribe((data: any) => {
          this.documentTypeData = data[0];
          this.appService.getAllDocumentReportHeaderTemplates().subscribe((response: any) => {
            this.dropdownForHeaderReportTemplate = [];
            if (data[0].reportHeaderTemplateId != null) {
              let ids = data[0].reportHeaderTemplateId.split(",");
              const numericIdsSet = new Set(ids.map(Number));
              const newDropdownItems = response
                .filter((item: any) => numericIdsSet.has(item.templateId))
                .map((item: any) => ({
                  valueExp: item.templateId,
                  displayExp: item.templateName
                }));

              this.dropdownForHeaderReportTemplate = [
                ...this.dropdownForHeaderReportTemplate,
                ...newDropdownItems
              ];
            }

          })
        })
    }

    this.isProcessing = true;
    this.appService.getOneQmsOrganizationReportImage().subscribe({
      next: (data: any) => {
        this.organizationReportImageDetails = data;
        this.appService.getQmsReportLogoByModuleAndGroupId("DOCS", this.folderId).subscribe((data: any) => {
          this.dropDownDataForReportLogo = data;
          this.selectBoxForReportLogo();
        });

        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
      }
    })
    this.appService.getCodeListsByGroup("DOCUMENT_ISSUANCE_TYPE").subscribe((data: any) => {
      this.listOfDmsIssuanceTypes = data;

    })
  }
  populateFormWithTemplateData(template: any) {
    if (!template) return;

    setTimeout(() => {
      console.log("Populating Form Data for:", template.templateName);

      this.issuanceTo = template.issuedTo;
      this.issuanceCopy = template.printsTaken;
      this.issuanceReason = template.issuanceReason;
      this.comments = template.comments;
      this.incudeNotesTitle = template.notesDetail;
      this.historyYear = template.totalYears;
      this.incudeAdditionalDetailsTitle = template.includeAddlDetailsName;

      if (template.reportLogoId) {
        this.selectedReportLogoValue = Number(template.reportLogoId);
      }
      this.incudeCoverPgae = template.coverPageOrSign === 'Y';
      this.incudeApproval = template.approval === 'Y';
      this.incudeRevisionhistory = template.revisionHistory === 'Y';
      this.incudeAdditionalDetails = template.incudeAdditionalDetails === 'Y';
      this.completeHistory = template.completeHistory === 'Y';
      this.incudeAmendment = template.amendment === 'Y';
      this.onLastPage = template.onLastPage === 'Y';
      this.incudeFooter = template.footer === 'Y';
      this.incudePageNo = template.pageNumber === 'Y';
      this.publisherDetails = template.publisherDetails === 'Y';
      this.linkedDocuments = template.linkedDocuments === 'Y';
      this.incudeNotes = template.notes === 'Y';
      this.isLatestOnTop = template.isLatestOnTop === 'Y';
      this.incudeAdditionalDetails = template.includeAddlDetails === 'Y';
      this.incudeCoverPgaeTitle = template.coverPageOrSignPageName;
      this.incudeApprovalTitle = template.approvalPageName;
      this.incudeRevisionhistoryTitle = template.revisionHistoryPageName;
      this.incudeAmendmentTitle = template.amendmentPageName;
      this.incudeAdditionalDetailsTitle = template.includeAddlDetailsName;
      this.toggleChanged({ checked: this.incudeCoverPgae });
      this.onApprovalToggleChanged({ checked: this.incudeApproval });
    }, 100);
  }
  issuanceTypeSearchText: string = '';
  ReportHeaderSearchText: string = '';
  selectedOptionforDownload: any = "Issue Document";
  completeHistory: boolean = false;
  documentHistList: any = [];
  savedReportsList: any = [];
  documentIssuanceTypeDropdown: any = [];
  documentIssuanceTypeList: any = [];
  radioButtonDownloadChange(data: MatRadioChange) {
    this.selectedOptionforDownload = data.value;
    if (data.value == 'Issue Document') {
      this.resetDownloadData();
      this.completeHistory = true;
      this.isProcessing = true;
      this.loadIssuanceTypes();
    } else {

      this.resetDownloadData();
      this.selectedIssuanceValue = "Revision History";
      this.documentIssuanceIncludeType = "Revision History";
      this.completeHistory = true;
    }
  }

  onDownloadTemplateSelect(event: any) {
    const templateId = event.value;
    if (!templateId) {
      this.resetDownloadData();
      this.selectedReportLogoValue = null;
      this.isShowOnLatestTopDisabled = false;
      this.substitueWaterMsg();
      return;
    }

    const templateObj = this.downloadTemplatesList.find(
      (t: any) => t.templateId === templateId
    );

    if (templateObj) {
      this.populateFormWithTemplateData(templateObj);
    }
  }

  private validateIssuanceCopyField(): boolean {
    if (this.issuanceCopy == null || this.issuanceCopy == undefined || this.issuanceCopy < 1 || Number.isNaN(this.issuanceCopy)) {
      this.issuanceCopyInvalid = true;
      return false;
    }
    this.issuanceCopyInvalid = false;
    return true;
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }
  documentIssuanceTypeAddDropdown: any = [];
  documentIssuanceAddType: any;
  documentIssuanceTypeAddList: any = ["Cover page / Sign", "Revision history", "Amendment", "Approval"];
  documentIssuanceTypeIncludeList: any = ["Footer", "Page Number", "Publisher details", "Linked documents", "Notes"];

  documentIssuanceTypeIncludeDropdown: any = [];

  documentIssuanceType: any = null;

  documentIssuanceIncludeType: any = "Issue Document";
  typeDmsDocumentsVw: { documentId: any; version: any; };
  issuanceReason: any;
  issuanceTo: any;
  issuanceCopy: any;

  typeDmsDocumentsVwaterMark: { documentId: any; version: any; printParentDetails: string; documentTypeCode: any; issuanceReason: any; issuanceTo: any; noOfCopy: any; };
  incudeCoverPgae: any = false;
  incudeCoverPgaeTitle: any;
  incudeRevisionhistory: any = false;
  incudeRevisionhistoryTitle: any;
  incudeAdditionalDetails: any = false;
  incudeAdditionalDetailsTitle: any;
  incudeFooter: any = false;
  incudeFooterTitle: any;
  incudeAmendmentTitle: any;
  incudeAmendment: any = false;
  incudeApproval: any = false;
  incudeApprovalTitle: any;

  selectedIssuanceValue: any;
  onLastPage: boolean;
  incudePageNo: any = false;
  publisherDetails: any = false;
  linkedDocuments: any;
  incudeNotes: any = false;
  incudeNotesTitle: any;
  documentWatermark: any;
  documentNameForDownload: any;
  historyYear: any = null;
  isLatestOnTop: boolean = true;
  watermarkColor: any;
  loadIssuanceTypes() {
    this.isProcessing = true;
    this.typeDmsDocumentsVw = {
      documentId: null,
      version: null,
    };

    if (this.isFrom == "BULK") {
      this.typeDmsDocumentsVw.documentId = this.selectedDocList[0].documentId;
      this.typeDmsDocumentsVw.version = this.selectedDocList[0].version;
    } else {
      this.typeDmsDocumentsVw.documentId = this.documentData.documentId;
      this.typeDmsDocumentsVw.version = this.documentData.version;
    }

    this.appService.getDocumentType(this.typeDmsDocumentsVw).subscribe({
      next: (responsedata: any) => {
        this.isProcessing = false;
        this.documentIssuanceTypeDropdown = [];
        this.documentIssuanceTypeList = responsedata;

        this.documentIssuanceTypeDropdown = [
          ...this.documentIssuanceTypeDropdown,
          ...this.documentIssuanceTypeList.map((type: any) => ({
            valueExp: type,
            displayExp: type
          }))
        ];

      }, error: (error) => {
        this.isProcessing = false;
      }
    });

    this.documentIssuanceTypeAddDropdown = [];
    this.documentIssuanceTypeAddDropdown = [
      ...this.documentIssuanceTypeAddDropdown,
      ...this.documentIssuanceTypeAddList.map((type: any) => ({
        valueExp: type,
        displayExp: type,
        isChecked: false,
        title: type
      }))
    ];

    this.documentIssuanceTypeIncludeDropdown = [];
    this.documentIssuanceTypeIncludeDropdown = [
      ...this.documentIssuanceTypeIncludeDropdown,
      ...this.documentIssuanceTypeIncludeList.map((type: any) => ({
        valueExp: type,
        displayExp: type
      }))
    ];
  }
  documentIssuanceSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.isIssuanceTypeInvalid = false;
      if (item) {
        this.selectedIssuanceValue = item.valueExp;
        this.documentIssuanceIncludeType = this.selectedIssuanceValue;
        const matchedIssuanceType = this.listOfDmsIssuanceTypes.find(
          (type: any) => type.codelistName === this.selectedIssuanceValue
        );

        if (matchedIssuanceType) {
          this.watermarkColor = matchedIssuanceType.subgroupValues;
        }
        if (this.isFrom != "BULK") {
          this.callWatermark();
        }

      }
    }
  }

  callWatermark() {
    this.typeDmsDocumentsVwaterMark = {

      documentId: this.documentData.documentId,
      version: this.documentData.version,
      printParentDetails: "Y",
      documentTypeCode: this.selectedIssuanceValue,
      issuanceReason: this.issuanceReason,
      issuanceTo: this.issuanceTo,
      noOfCopy: this.issuanceCopy

    };
    this.documentIssuanceIncludeType = this.selectedIssuanceValue;
    this.appService.getDocumentWatermark(this.typeDmsDocumentsVwaterMark).subscribe((response: any) => {
      this.isProcessing = false;
      this.documentWatermark = response.result;
    })
    this.appService.getDocumentNameForDownload(this.typeDmsDocumentsVwaterMark).subscribe((response: any) => {
      this.isProcessing = false;
      this.documentNameForDownload = response.documentName;
    })
  }

  documentIssuanceSelectOld(item: any) {
    this.selectedIssuanceValue = item.valueExp;
    this.typeDmsDocumentsVwaterMark = {
      documentId: this.documentData.documentId,
      version: this.documentData.version,
      printParentDetails: "Y",
      documentTypeCode: item.valueExp,
      issuanceReason: this.issuanceReason,
      issuanceTo: this.issuanceTo,
      noOfCopy: this.issuanceCopy

    };
    this.documentIssuanceIncludeType = item.valueExp;
    this.appService.getDocumentWatermark(this.typeDmsDocumentsVwaterMark).subscribe((responsedata: any) => {
      this.isProcessing = false;
      this.documentWatermark = responsedata.result;

    })
    this.appService.getDocumentNameForDownload(this.typeDmsDocumentsVwaterMark).subscribe((response: any) => {
      this.isProcessing = false;
      this.documentNameForDownload = response.documentName;
    })
  }

  checkBoxCheckedforadd(event: any, val: any) {
    val.isChecked = event.checked;
  }

  checkBoxisLatestOnTop(event: any) {
    this.isLatestOnTop = event.checked;
  }

  substitueWaterMsg() {
    if (this.isFrom != "BULK") {
      this.callWatermark();
    }

  }


  isShowOnLatestTopDisabled = false;
  toggleChanged(event: any) {
    this.isShowOnLatestTopDisabled = event.checked;

    if (event.checked) {
      this.onLastPage = true;
    }
  }

  onApprovalToggleChanged(event: any) {
    if (event.checked) {
      this.onLastPage = true;
    }
  }

  cancelDownloadFunction() {
    this.valueChange.emit(true);
  }

  downloadForrevisonHistory() {

    this.isProcessing = true;
    let obj = {
      documentId: this.documentData.documentId,
      version: this.documentData.version,
      documentTypeCode: this.documentIssuanceIncludeType,
      printParentDetails: "Y",
      effectiveDate: this.documentData.effectiveDate,
      expirationDate: this.documentData.expirationDate,
      documentName: this.documentData.documentName,
      documentNo: this.documentData.documentNo,
      parentDocId: this.documentData.associatedDocumentId,
      incudeCoverPgae: this.incudeCoverPgae,
      incudeCoverPgaeTitle: this.incudeCoverPgaeTitle,
      incudeRevisionhistory: this.incudeRevisionhistory,
      incudeRevisionhistoryTitle: this.incudeRevisionhistoryTitle,
      incudeAdditionalDetails: this.incudeAdditionalDetails,
      incudeAdditionalDetailsTitle: this.incudeAdditionalDetailsTitle,
      documentTypeName: this.documentTypeData.documentTypeName,
      incudeFooter: this.incudeFooter,
      incudeFooterTitle: this.incudeFooterTitle,
      incudeAmendment: this.incudeAmendment,
      incudeAmendmentTitle: this.incudeAmendmentTitle,
      incudeApproval: this.incudeApproval,
      incudeApprovalTitle: this.incudeApprovalTitle,
      watermarkMsg: this.documentWatermark,
      onLastPage: this.onLastPage,
      completeHistory: this.completeHistory,
      historyYear: this.historyYear,
      isLatestOnTop: this.isLatestOnTop,
      incudePageNo: this.incudePageNo,
      publisherDetails: this.publisherDetails,
      linkedDocuments: this.linkedDocuments ?? false,
      watermarkColor: this.watermarkColor
    }
    if (this.documentData.effectiveDate != null) {
      const effectiveDateValue = new Date(this.documentData.effectiveDate);
      obj.effectiveDate = this.appService.dateZoneConvertion(effectiveDateValue);
    }
    if (this.documentData.expirationDate != null) {
      const expirationDateValue = new Date(this.documentData.expirationDate);
      obj.expirationDate = this.appService.dateZoneConvertion(expirationDateValue);
    }

  }

  validateYear(event: any) {
    if (event.key === 'e' || event.key === 'E' || event.key === '+' || event.key === '-' || event.key === '.') {
      event.preventDefault();
    }
  }

  commentsCss: any;
  commentsCssReqdMsg: any;
  fieldValidation() {
    this.commentsCss = document.getElementById('comments') as HTMLInputElement;
    this.commentsCssReqdMsg = document.getElementById('comments-required-msg') as HTMLInputElement;

    if (this.comments == null || this.comments == "") {
      this.commentsCss.style.border = '1px solid red';
      this.commentsCssReqdMsg.style.display = 'block';
    } else {
      this.commentsCss.style.border = 'none';
      this.commentsCssReqdMsg.style.display = 'none';
    }
  }
  isIssuanceTypeInvalid: boolean = false;
  saveFrom: any;
  comments: any = "";
  downloadFordocument(val: any) {
    if (this.selectedOptionforDownload === 'Issue Document' && !this.documentIssuanceType) {
      this.isIssuanceTypeInvalid = true;
      return;
    }
    if (this.documentNameForDownload) {
      this.documentNameForDownload = this.documentNameForDownload.replaceAll(/[.,]/g, '_');
    }
    this.saveFrom = val;
    if (this.isFrom == "REDACT" && (this.comments == "" || this.comments == null)) {
      this.fieldValidation();
    } else {
      let otherDetails = "";
      if (this.isFrom == "REDACT") {
        let footer = this.incudeFooter ? "Y" : "N";
        let pageNo = this.incudePageNo ? "Y" : "N";
        let notes = this.incudeNotesTitle ?? " ";
        otherDetails = "DOC_REDACT : Yes\n Footer : " + footer + "\n"
          + "Page No : " + pageNo + "\n"
          + "Notes : " + notes + "\n"
        this.comments;
      } else if (this.isFrom == "BULK") {
        for (const doc of this.selectedDocList ?? []) {
          otherDetails += `${doc.documentNo} (${doc.documentId}/${doc.version} )\n `;
        }
      } else {
        let footer = this.incudeFooter ? "Y" : "N";
        let pageNo = this.incudePageNo ? "Y" : "N";
        let notes = this.incudeNotesTitle ?? " ";
        otherDetails = "Footer : " + footer + "\n"
          + "Page No : " + pageNo + "\n"
          + "Notes : " + notes + "\n";
      }
      let list: any = [];
      if (this.isFrom == "BULK") {

        for (const doc of this.selectedDocList ?? []) {
          const obj: Record<string, unknown> = {};

          obj['documentId'] = doc.documentId;
          obj['version'] = doc.version;
          obj['documentTypeCode'] = this.documentIssuanceIncludeType;
          obj['printParentDetails'] = "Y";
          obj['effectiveDate'] = doc.effectiveDate;
          obj['expirationDate'] = doc.expirationDate;
          obj['documentName'] = doc.documentName;
          obj['documentNo'] = doc.documentNo;
          obj['parentDocId'] = doc.associatedDocumentId;
          obj['incudeCoverPgae'] = this.incudeCoverPgae;
          obj['incudeCoverPgaeTitle'] = this.incudeCoverPgaeTitle;
          obj['incudeRevisionhistory'] = this.incudeRevisionhistory;
          obj['incudeRevisionhistoryTitle'] = this.incudeRevisionhistoryTitle;
          obj['incudeAdditionalDetails'] = this.incudeAdditionalDetails;
          obj['incudeAdditionalDetailsTitle'] = this.incudeAdditionalDetailsTitle;
          obj['documentTypeName'] = this.documentTypeData?.documentTypeName;
          obj['incudeFooter'] = this.incudeFooter;
          obj['incudeFooterTitle'] = this.incudeFooterTitle;
          obj['incudeAmendment'] = this.incudeAmendment;
          obj['incudeAmendmentTitle'] = this.incudeAmendmentTitle;
          obj['incudeApproval'] = this.incudeApproval;
          obj['incudeApprovalTitle'] = this.incudeApprovalTitle;
          obj['watermarkMsg'] = this.documentWatermark;
          obj['onLastPage'] = this.onLastPage;
          obj['completeHistory'] = this.completeHistory;
          obj['historyYear'] = this.historyYear;
          obj['isLatestOnTop'] = this.isLatestOnTop;
          obj['incudePageNo'] = this.incudePageNo;
          obj['publisherDetails'] = this.publisherDetails ? "Y" : "N";
          obj['incudeNotes'] = this.incudeNotes ?? false;
          obj['incudeNotesTitle'] = this.incudeNotesTitle;
          obj['linkedDocuments'] = this.linkedDocuments ?? false;
          obj['issuanceReason'] = this.issuanceReason;
          obj['issuanceTo'] = this.issuanceTo;
          obj['noOfCopy'] = this.issuanceCopy;
          obj['watermarkColor'] = this.watermarkColor;
          obj['otherDetails'] = otherDetails;
          obj['comments'] = this.comments;
          obj['logoId'] = this.selectedReportLogoValue ?? null;
          obj['isPrintOrDownload'] = "Download";

          if (doc.effectiveDate != null) {
            const effectiveDateValue = new Date(doc.effectiveDate);
            obj['effectiveDate'] = this.appService.dateZoneConvertion(effectiveDateValue);
          }

          if (doc.expirationDate != null) {
            const expirationDateValue = new Date(doc.expirationDate);
            obj['expirationDate'] = this.appService.dateZoneConvertion(expirationDateValue);
          }

          this.typeDmsDocumentsVwaterMark = {

            documentId: doc.documentId,
            version: doc.version,
            printParentDetails: "Y",
            documentTypeCode: this.selectedIssuanceValue,
            issuanceReason: this.issuanceReason,
            issuanceTo: this.issuanceTo,
            noOfCopy: this.issuanceCopy
          };

          obj['dmsDocumentsDto'] = this.typeDmsDocumentsVwaterMark;
          list.push(obj);
        }
        this.processBulkDownloadsOneByOne(list, this.saveFrom);
      } else {
        let obj = {
          orgName: localStorage.getItem("orgLongName"),
          documentId: this.documentData.documentId,
          version: this.documentData.version,
          documentTypeCode: this.documentIssuanceIncludeType,
          printParentDetails: "Y",
          effectiveDate: this.documentData.effectiveDate,
          expirationDate: this.documentData.expirationDate,
          documentName: this.documentData.documentName,
          documentNo: this.documentData.documentNo,
          parentDocId: this.documentData.associatedDocumentId,
          incudeCoverPgae: this.incudeCoverPgae,
          incudeCoverPgaeTitle: this.incudeCoverPgaeTitle,
          incudeRevisionhistory: this.incudeRevisionhistory,
          incudeRevisionhistoryTitle: this.incudeRevisionhistoryTitle,
          incudeAdditionalDetails: this.incudeAdditionalDetails,
          incudeAdditionalDetailsTitle: this.incudeAdditionalDetailsTitle,
          documentTypeName: this.documentTypeData.documentTypeName,
          incudeFooter: this.incudeFooter,
          incudeFooterTitle: this.incudeFooterTitle,
          incudeAmendment: this.incudeAmendment,
          incudeAmendmentTitle: this.incudeAmendmentTitle,
          incudeApproval: this.incudeApproval,
          incudeApprovalTitle: this.incudeApprovalTitle,
          watermarkMsg: this.documentWatermark,
          onLastPage: this.onLastPage,
          completeHistory: this.completeHistory,
          historyYear: this.historyYear,
          isLatestOnTop: this.isLatestOnTop,
          incudePageNo: this.incudePageNo,
          publisherDetails: this.publisherDetails ? "Y" : "N",
          incudeNotes: this.incudeNotes ? this.incudeNotes : false,
          incudeNotesTitle: this.incudeNotesTitle,
          linkedDocuments: this.linkedDocuments ? this.linkedDocuments : false,
          issuanceReason: this.issuanceReason,
          issuanceTo: this.issuanceTo,
          noOfCopy: this.issuanceCopy,
          watermarkColor: this.watermarkColor,
          otherDetails: otherDetails,
          comments: this.comments,
          logoId: this.selectedReportLogoValue ?? null,
          reportHeaderTemplateId: this.selectedHeaderTemplate ?? null,
          reportHeaderName: this.documentTypeData.documentTypeNameAtReports,
          reportHeaderCode: this.documentTypeData.documentTypeCodeAtReports,
          isPrintOrDownload: "Download"
        };

        if (this.documentData.effectiveDate != null) {
          const effectiveDateValue = new Date(this.documentData.effectiveDate);
          obj.effectiveDate = this.appService.dateZoneConvertion(effectiveDateValue);
        }
        if (this.documentData.expirationDate != null) {
          const expirationDateValue = new Date(this.documentData.expirationDate);
          obj.expirationDate = this.appService.dateZoneConvertion(expirationDateValue);
        }
        this.callIssuancePkg(obj, this.saveFrom);
      }


      this.isProcessing = true;
      this.isProcessing = false;
    }
  }

  private getWatermarkForDoc(doc: any, issuanceType: string): Observable<any> {
    const payload = {
      documentId: doc.documentId,
      version: doc.version,
      printParentDetails: "Y",
      documentTypeCode: issuanceType,
      issuanceReason: this.issuanceReason,
      issuanceTo: this.issuanceTo,
      noOfCopy: this.issuanceCopy
    };
    return this.appService.getDocumentWatermark(payload);
  }

  isTrackerMinimized: boolean = false;

  toggleMinimizeTracker() {
    this.isTrackerMinimized = !this.isTrackerMinimized;
  }
  // Download Tracker Template and Dialog Reference
  @ViewChild('downloadTrackerPopup', { static: true }) downloadTrackerPopup: TemplateRef<any>;
  visibleDownloadTrackerPopup: MatDialogRef<TemplateRef<any>>;

  // Configuration for a floating, non-blocking popup in the bottom right
  downloadTrackerPopupConfig = {
    width: '400px',
    height: 'auto',
    hasBackdrop: false,     // <-- Crucial: Allows user to keep clicking the app behind it
    disableClose: true,
    panelClass: 'my-dialog',
    position: { top: 'calc(100vh - 350px)', right: '20px' },
  };

  downloadProgressList: any[] = [];
  closeDownloadTracker() {
    if (this.visibleDownloadTrackerPopup) {
      this.visibleDownloadTrackerPopup.close();
    }
  }

  async processBulkDownloadsOneByOne(dataList: Record<string, any>[], val: string): Promise<void> {
    this.isProcessing = false;
    this.valueChange.emit(true);

    if (val === "DOCDOWNLOAD") {
      this.downloadProgressList = dataList.map((data, index) => ({
        documentName: this.selectedDocList[index]?.documentName || `Document_${data['documentId']}`,
        status: 'Pending',
        errorMessage: ''
      }));
      this.visibleDownloadTrackerPopup = this.dialog.open(this.downloadTrackerPopup, this.downloadTrackerPopupConfig);
    }

    // Optimization: Move localStorage access outside the loop to resolve Sonar S7655

    // Use for...of with entries() to maintain index for parallel arrays
    for (const [i, currentPayload] of dataList.entries()) {
      const originalDoc = this.selectedDocList[i];
      const trackerItem = val === "DOCDOWNLOAD" ? this.downloadProgressList[i] : null;

      try {
        if (trackerItem) {
          trackerItem.status = 'Downloading...';
        }

        // 1. Fetch Watermark
        const watermarkPayload = {
          documentId: originalDoc?.documentId,
          version: originalDoc?.version,
          printParentDetails: "Y",
          documentTypeCode: currentPayload['documentTypeCode'],
          issuanceReason: this.issuanceReason,
          issuanceTo: this.issuanceTo,
          noOfCopy: this.issuanceCopy
        };

        // Replace deprecated toPromise() with lastValueFrom()
        const watermarkRes = await lastValueFrom(
          this.appService.getDocumentWatermark(watermarkPayload, true)
        ) as { result?: string };

        const specificWatermark = watermarkRes?.result ?? '';
        currentPayload['watermarkMsg'] = specificWatermark;

        // 2. Build Specific Other Details
        const footer = this.incudeFooter ? "Y" : "N";
        const pageNo = this.incudePageNo ? "Y" : "N";
        const notes = this.incudeNotesTitle || " ";
        const specificOtherDetails = `Footer: ${footer}\nPage No: ${pageNo}\nNotes: ${notes}`;

        // 3. Prepare Base History Object
        const historyObject: Record<string, any> = {

          documentId: currentPayload['documentId'],
          version: currentPayload['version'],
          folderId: originalDoc?.folderId,
          issuanceType: currentPayload['documentTypeCode'],
          issuanceReason: this.issuanceReason,
          issuanceTo: this.issuanceTo,
          noOfCopy: this.issuanceCopy,
          coverPage: this.incudeCoverPgae ? "Y" : "N",
          revisionHistory: this.incudeRevisionhistory ? "Y" : "N",
          additionalDetailsReqd: this.incudeAdditionalDetails ? "Y" : "N",
          amendment: this.incudeAmendment ? "Y" : "N",
          approval: this.incudeApproval ? "Y" : "N",
          associatedDocuments: this.linkedDocuments ? "Y" : "N",
          publisherDetails: currentPayload['publisherDetails'],
          otherDetails: specificOtherDetails,
          comments: currentPayload['comments'],
          watermark: specificWatermark,
          issuanceId: null,
          downloadedFileName: currentPayload['documentName'],
          isPrintOrDownload: currentPayload['isPrintOrDownload'],
          status: 'Completed',
        };

        // 4. Send History Record
        const historyRes = await lastValueFrom(
          this.appService.performIssuanceHistory(historyObject, true)
        ) as { resultType: string; result?: string; issuanceId?: string };

        if (historyRes?.resultType === "S") {
          currentPayload['issuanceId'] = historyRes.issuanceId;
          currentPayload['status'] = "Completed";

          // 5. Fetch File or Submit Job
          if (val === "DOCDOWNLOAD") {
            const response = await lastValueFrom(
              this.appService.downloadDocumentsDms(currentPayload, currentPayload['documentName'], true)
            ) as Blob;

            if (response?.type) {
              let filename = currentPayload['documentName']
                ? `${currentPayload['documentName']}.pdf`
                : `Document_${currentPayload['documentId']}.pdf`;

              // Logic for file name sanitization preserved exactly
              filename = filename.replaceAll(/[.,](?=.*[.,])/g, '_');

              this.handleFileResponse(response, filename);

              if (trackerItem) {
                trackerItem.status = 'Success';
              }
              await new Promise(resolve => setTimeout(resolve, 1600));
            } else {
              throw new Error("Download API failed: Invalid file data received");
            }
          } else {
            // DOCSAVE Flow
            await lastValueFrom(this.appService.submitJobDmsSingleDocument(currentPayload, true));
            if (trackerItem) {
              trackerItem.status = 'Success';
            }
          }
        } else {
          console.error("Backend returned history failure:", historyRes);
          throw new Error(historyRes?.result || 'Failed to record history to database');
        }

      } catch (error: any) {
        console.error(`Error processing ${currentPayload['documentId']}:`, error);
        if (trackerItem) {
          trackerItem.status = 'Failed';
          trackerItem.errorMessage = error.message || 'Server Error';
        }
      }
    }

    if (val !== "DOCDOWNLOAD") {
      this.warningMsg = "All jobs have been triggered successfully.";
      this.visibleInfoPopup = this.dialog.open(this.infoPopup, this.infoPopupConfig);
    }
  }
  downloadForPrint(val: any) {
    if (this.selectedOptionforDownload === 'Issue Document' && !this.documentIssuanceType) {
      this.isIssuanceTypeInvalid = true;
      return;
    }

    if (this.isPrintMode) {
      if (!this.validateIssuanceCopyField()) {
        // Show snackbar if validation fails
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: 'Please fill in the "Prints Taken" field.',
            type: 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: 'Error',
        });
        sb.onAction().subscribe(() => sb.dismiss());
        return;
      }
    }

    if (this.documentNameForDownload) {
      this.documentNameForDownload = this.documentNameForDownload.replaceAll(/[.,]/g, '_');
    }
    this.saveFrom = val;
    let otherDetails = "";
    let footer = this.incudeFooter ? "Y" : "N";
    let pageNo = this.incudePageNo ? "Y" : "N";
    let notes = this.incudeNotesTitle ?? " ";
    otherDetails = "Footer : " + footer + "\n"
      + "Page No : " + pageNo + "\n"
      + "Notes : " + notes + "\n";
    let list: any = [];
    let obj = {

      orgName: localStorage.getItem("orgLongName"),
      documentId: this.documentData.documentId,
      version: this.documentData.version,
      documentTypeCode: this.documentIssuanceIncludeType,
      printParentDetails: "Y",
      effectiveDate: this.documentData.effectiveDate,
      expirationDate: this.documentData.expirationDate,
      documentName: this.documentData.documentName,
      documentNo: this.documentData.documentNo,
      parentDocId: this.documentData.associatedDocumentId,
      incudeCoverPgae: this.incudeCoverPgae,
      incudeCoverPgaeTitle: this.incudeCoverPgaeTitle,
      incudeRevisionhistory: this.incudeRevisionhistory,
      incudeRevisionhistoryTitle: this.incudeRevisionhistoryTitle,
      incudeAdditionalDetails: this.incudeAdditionalDetails,
      incudeAdditionalDetailsTitle: this.incudeAdditionalDetailsTitle,
      documentTypeName: this.documentTypeData.documentTypeName,
      incudeFooter: this.incudeFooter,
      incudeFooterTitle: this.incudeFooterTitle,
      incudeAmendment: this.incudeAmendment,
      incudeAmendmentTitle: this.incudeAmendmentTitle,
      incudeApproval: this.incudeApproval,
      incudeApprovalTitle: this.incudeApprovalTitle,
      watermarkMsg: this.documentWatermark,
      onLastPage: this.onLastPage,
      completeHistory: this.completeHistory,
      historyYear: this.historyYear,
      isLatestOnTop: this.isLatestOnTop,
      incudePageNo: this.incudePageNo,
      publisherDetails: this.publisherDetails ? "Y" : "N",
      incudeNotes: this.incudeNotes ?? false,
      incudeNotesTitle: this.incudeNotesTitle,
      linkedDocuments: this.linkedDocuments ?? false,
      issuanceReason: this.issuanceReason,
      issuanceTo: this.issuanceTo,
      noOfCopy: this.issuanceCopy,
      watermarkColor: this.watermarkColor,
      otherDetails: otherDetails,
      comments: this.comments,
      logoId: this.selectedReportLogoValue ?? null,
      reportHeaderTemplateId: this.selectedHeaderTemplate ?? null,
      reportHeaderName: this.documentTypeData.documentTypeNameAtReports,
      reportHeaderCode: this.documentTypeData.documentTypeCodeAtReports,
      isPrintOrDownload: this.isPrintMode ? 'Preview' : 'Download',
    };

    if (this.documentData.effectiveDate != null) {
      const effectiveDateValue = new Date(this.documentData.effectiveDate);
      obj.effectiveDate = this.appService.dateZoneConvertion(effectiveDateValue);
    }
    if (this.documentData.expirationDate != null) {
      const expirationDateValue = new Date(this.documentData.expirationDate);
      obj.expirationDate = this.appService.dateZoneConvertion(expirationDateValue);
    }

    if (this.isPrintMode) {
      this.callPrint(obj, val);
    } else { this.previewPrint(obj, val) }


  }
  areFormFieldsFilled(): boolean {

    return (
      this.documentIssuanceType != null ||
      this.issuanceReason?.trim() !== '' ||
      this.issuanceTo?.trim() !== '' ||
      this.issuanceCopy > 0 ||
      this.incudeCoverPgae === true ||
      this.incudeRevisionhistory === true ||
      this.incudeAdditionalDetails === true ||
      this.incudeAmendment === true ||
      this.incudeApproval === true ||
      this.publisherDetails === true ||
      this.linkedDocuments === true ||
      this.incudeFooter === true ||
      this.incudePageNo === true ||
      this.incudeNotes === true ||
      this.comments?.trim() !== '' ||
      this.documentWatermark?.trim() !== '' ||
      this.documentNameForDownload?.trim() !== ''
    );
  }

  private handleFileResponse(response: any, filename?: string): void {
    const dataType = response.type;
    const binaryData = [response];
    const blob = new Blob(binaryData, { type: dataType });

    if (this.areFormFieldsFilled()) {
      const downloadLink = document.createElement('a');
      const blobUrl = globalThis.URL.createObjectURL(blob);

      downloadLink.href = blobUrl;
      downloadLink.setAttribute('download', filename ?? 'document.pdf');
      document.body.appendChild(downloadLink);
      downloadLink.click();

      downloadLink.remove();

      globalThis.URL.revokeObjectURL(blobUrl);
    } else {
      const blobUrl = globalThis.URL.createObjectURL(blob);
      globalThis.open(blobUrl, '_blank');

      setTimeout(() => globalThis.URL.revokeObjectURL(blobUrl), 100);
    }
  }
  visibleInfoPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('infoPopup', { static: true }) infoPopup: TemplateRef<any>;

  infoPopupConfig = {
    width: '500px',
    minHeight: '200px',
    maxHeight: '80vh',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  warningMsg: any;
  private printSubscription: Subscription | null = null;


  callPrint(data1: any, val: any) {
    let issuanceHistoryObject = {

      documentId: this.documentData.documentId,
      version: this.documentData.version,
      folderId: this.documentData.folderId,
      issuanceType: data1.documentTypeCode,
      issuanceReason: this.issuanceReason,
      issuanceTo: this.issuanceTo,
      noOfCopy: this.issuanceCopy,
      coverPage: this.incudeCoverPgae ? "Y" : "N",
      revisionHistory: this.incudeRevisionhistory ? "Y" : "N",
      additionalDetailsReqd: this.incudeAdditionalDetails ? "Y" : "N",
      amendment: this.incudeAmendment ? "Y" : "N",
      approval: this.incudeApproval ? "Y" : "N",
      associatedDocuments: this.linkedDocuments ? "Y" : "N",
      publisherDetails: data1.publisherDetails,
      otherDetails: data1.otherDetails,
      comments: data1.comments,
      watermark: this.documentWatermark,
      issuanceId: null,
      downloadedFileName: this.documentNameForDownload,
    };

    this.isProcessing = true;
    this.appService.downloadDocumentsDmsForPrintPreview(data1, this.documentData.documentName).subscribe({
      next:
        (response: any) => {
          if (response.status === 200) {
            this.isProcessing = false;
            const contentType = response.headers.get('content-type');
            const blob = new Blob([response.body], { type: contentType });
            const doc = { body: response.body, contentType, extn: 'pdf' };
            this.docViewer = {
              blob,
              doc,
              docName: this.documentNameForDownload,
              docExtension: 'pdf',
              isFromOnlyPreview: false,
              printPayloadData: data1
            };

            setTimeout(() => {
              if (this.documentViewerPrinterComponent) {
                // BEFORE registering new subscription, unsubscribe old one
                if (this.printSubscription) {
                  this.printSubscription.unsubscribe();
                  this.printSubscription = null;
                }

                // SAVE the new subscription
                this.printSubscription = this.documentViewerPrinterComponent.closePopupsAfterPrint
                  .subscribe(() => {
                    console.log("DocumentViewerPrinterComponent emitted printInitiated event.");

                    // cleanup
                    this.printSubscription?.unsubscribe();
                    this.printSubscription = null;

                    this.valueChange.emit(true);

                    this.appService.performIssuanceHistory(issuanceHistoryObject).subscribe(
                      (historyResponse: any) => {
                        console.log("Issuance history saved for print:", historyResponse);
                      }
                    );
                  });

                this.documentViewerPrinterComponent.openPopUp();
              } else {
                console.error("DocumentViewerPrinterComponent reference is still not available inside setTimeout.");
                this.snackBar.open('Error: Printer component could not be initialized.', 'Close', { duration: 3000 });
              }
            }, 10);

          } else {
            alert("Error Occurred: " + response.status);
          }
        }, error:
        (error) => {
          this.isProcessing = false;
          console.error("Error downloading document", error);
        }
    }
    );
  }

  // In document-download.component.ts

  previewPrint(data1: any, val: any) {
    // Use the same service call
    this.appService.downloadDocumentsDmsForPrintPreview(data1, this.documentData.documentName).subscribe({
      next:
        (response: any) => {
          console.log("previewPrint response.status =", response.status);
          if (response.status === 200) {
            this.isProcessing = false;
            const contentType = response.headers.get('content-type');
            const blob = new Blob([response.body], { type: contentType });
            const doc = { body: response.body, contentType, extn: 'pdf' };

            // Since this is called from the Preview flow (not print), isFromOnlyPreview should be true
            this.docViewer = {
              blob,
              doc,
              docName: this.documentNameForDownload,
              docExtension: 'pdf',
              isFromOnlyPreview: true
            };
            console.log("previewPrint docViewer =", this.docViewer);
            setTimeout(() => {
              this.documentViewerComponent?.openPopUp();
            });
          } else {
            alert("Error Occurred: " + response.status);
          }
        }, error:
        (error) => {
          this.isProcessing = false;
          console.error("Error in previewPrint:", error);
        }
    }
    );
  }

  // ... rest of your component ...

  callIssuancePkg(data1: any, val: any) {
    let object = {};
    if (this.isFrom == "BULK") {
      object = {

        documentId: 0,
        version: 0,
        folderId: data1[0].folderId,
        issuanceType: data1[0].documentTypeCode,
        issuanceReason: this.issuanceReason,
        issuanceTo: this.issuanceTo,
        noOfCopy: this.issuanceCopy,
        coverPage: this.incudeCoverPgae ? "Y" : "N",
        revisionHistory: this.incudeRevisionhistory ? "Y" : "N",
        additionalDetailsReqd: this.incudeAdditionalDetails ? "Y" : "N",
        amendment: this.incudeAmendment ? "Y" : "N",
        approval: this.incudeApproval ? "Y" : "N",
        associatedDocuments: this.linkedDocuments ? "Y" : "N",
        publisherDetails: data1[0].publisherDetails,
        otherDetails: data1[0].otherDetails,
        comments: data1[0].comments,
        watermark: this.documentWatermark,
        issuanceId: null,
        downloadedFileName: this.selectedDocList[0].folderName,
        isPrintOrDownload: data1[0].isPrintOrDownload,
      }
    } else {
      object = {

        documentId: this.documentData.documentId,
        version: this.documentData.version,
        folderId: this.documentData.folderId,
        issuanceType: data1.documentTypeCode,
        issuanceReason: this.issuanceReason,
        issuanceTo: this.issuanceTo,
        noOfCopy: this.issuanceCopy,
        coverPage: this.incudeCoverPgae ? "Y" : "N",
        revisionHistory: this.incudeRevisionhistory ? "Y" : "N",
        additionalDetailsReqd: this.incudeAdditionalDetails ? "Y" : "N",
        amendment: this.incudeAmendment ? "Y" : "N",
        approval: this.incudeApproval ? "Y" : "N",
        associatedDocuments: this.linkedDocuments ? "Y" : "N",
        publisherDetails: data1.publisherDetails,
        otherDetails: data1.otherDetails,
        comments: data1.comments,
        watermark: this.documentWatermark,
        issuanceId: null,
        downloadedFileName: this.documentNameForDownload,
        isPrintOrDownload: data1.isPrintOrDownload,
      }
    }

    this.isProcessing = true;
    this.appService.performIssuanceHistory(object).subscribe((data: any) => {
      this.isProcessing = false;
      if (data.resultType == "S") {
        if (this.isFrom == "BULK") {
          data1[0].issuanceId = data.issuanceId;
        } else {
          data1.issuanceId = data.issuanceId;
        }

        if (val == "DOCDOWNLOAD") {
          if (this.isFrom == "REDACT") {
            const formData = new FormData();
            formData.append('file', this.file);
            const json = JSON.stringify(data1);
            const blob = new Blob([json], { type: 'application/json' });
            formData.append('dmsDocumentsDownloadDto', blob);
            this.isProcessing = true;

            this.appService.downloadReadcatedDocument(formData).subscribe({
              next:
                (response: any) => {
                  this.handleFileResponse(response);
                  this.valueChange.emit(true);
                  this.isProcessing = false;
                }, error:
                (error) => {
                  this.isProcessing = false;
                  console.error("Error downloading redacted document", error);
                }
            }
            );

          } else if (this.isFrom == "BULK") {
            let folderName = this.selectedDocList[0].folderName.replaceAll(".", "_");
            this.isProcessing = true;

            this.appService.bulkDownloadDocumentsDms(data1).subscribe({
              next:
                (response: any) => {
                  this.handleFileResponse(response, folderName);
                  this.valueChange.emit(true);
                  this.isProcessing = false;
                }, error:
                (error) => {
                  this.isProcessing = false;
                  console.error("Error bulk downloading documents", error);
                }
            }
            );

          } else {
            this.isProcessing = true;

            this.appService.downloadDocumentsDms(data1, this.documentData.documentName).subscribe({
              next:
                (response: any) => {
                  this.handleFileResponse(response, this.documentNameForDownload);
                  this.valueChange.emit(true);
                  this.isProcessing = false;
                }, error:
                (error) => {
                  this.isProcessing = false;
                  console.error("Error downloading document", error);
                }
            }
            );
          }

        } else {
          this.valueChange.emit(true);
          this.warningMsg = "Job has been triggered, please download the document from issuance history on the home page.";
          this.visibleInfoPopup = this.dialog.open(this.infoPopup, this.infoPopupConfig);

          if (this.isFrom == "REDACT") {
            const formData = new FormData();
            formData.append('file', this.file);
            const json = JSON.stringify(data1);
            const blob = new Blob([json], { type: 'application/json' });
            formData.append('dmsDocumentsDownloadDto', blob);
            this.appService.saveRedactedDocument(formData).subscribe(() => { });
          } else if (this.isFrom == "BULK") {
            this.appService.bulkSaveDocumentsDms(data1, true).subscribe(() => { });
          } else {
            this.appService.submitJobDmsSingleDocument(data1, true).subscribe(() => { });
          }
        }

      } else {
        this.isProcessing = false;
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: data.result,
            type: data.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: data.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => sb.dismiss());
      }
    });
  }

  resetDownloadData() {
    this.linkedDocuments = false;
    this.issuanceReason = null;
    this.issuanceTo = null;
    this.issuanceCopy = null;
    this.completeHistory = false;
    this.onLastPage = false;
    this.incudeRevisionhistory = false;
    this.incudeRevisionhistoryTitle = null;
    this.incudeAdditionalDetails = false;
    this.incudeAdditionalDetailsTitle = null;
    this.incudeCoverPgae = false;
    this.incudeCoverPgaeTitle = null;
    this.incudeAmendment = false;
    this.incudeAmendmentTitle = null;
    this.incudeApproval = false;
    this.incudeApprovalTitle = null;
    this.historyYear = null;
    this.isLatestOnTop = false;
    this.incudeFooter = false;
    this.incudePageNo = false;
    this.publisherDetails = false;
    this.incudeNotes = false;
    this.incudeNotesTitle = null;
    this.comments = null;
    this.selectedDownloadTemplate=null;
  }

  okInfo() {
    this.visibleInfoPopup.close();
  }

  dropDownDataForReportLogo: any;
  selectedReportLogoValue: any = null;
  reportLogoDropdown: any = [];
  imageIdList: any = [];
  organizationReportImageDetails: any = {};
  logoVals: any;
  selectBoxForReportLogo() {
    this.reportLogoDropdown = [];
    if (this.dropDownDataForReportLogo) {
      if (this.dropDownDataForReportLogo.reportImageList == 'Default') {
        this.reportLogoDropdown = this.reportLogoDropdown.concat({
          valueExp: 0,
          displayExp: 'Default'
        });
      } else if (this.dropDownDataForReportLogo.reportImageList.includes(",")) {
        this.imageIdList = this.dropDownDataForReportLogo.reportImageList.split(",");
        for (let i = 0; i < this.imageIdList.length; i++) {
          if (i == 0 && this.imageIdList[i] == 'Default') {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: 0,
              displayExp: 'Default'
            });
          } else {
            for (const image of this.organizationReportImageDetails ?? []) {

              if (image.reportImageId === this.imageIdList[i]) {
                this.reportLogoDropdown.push({
                  valueExp: image.reportImageId,
                  displayExp: image.reportImageName
                });
              }
            }
          }
        }
      } else {
        for (const image of this.organizationReportImageDetails ?? []) {
          if (image.reportImageId === this.dropDownDataForReportLogo?.reportImageList) {
            this.reportLogoDropdown.push({
              valueExp: image.reportImageId,
              displayExp: image.reportImageName
            });
          }
        }
      }
      this.selectedReportLogoValue = this.reportLogoDropdown[0].valueExp;
    } else {
      this.selectedReportLogoValue = [];
    }
  }

  pdfDetailSearchText: string = '';
  templateid: number;
  onReportLogoValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.templateid = item;
    }
  }

  selectedHeaderTemplate: any;
  onHeaderTemplateSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.selectedHeaderTemplate = item.valueExp;
    }
  }

  validateIssuanceCopy(event: KeyboardEvent) {
    const invalidKeys = ['-', '+', 'e', 'E', '.'];
    const currentValue = (event.target as HTMLInputElement).value;

    // Prevent invalid characters
    if (invalidKeys.includes(event.key)) {
      event.preventDefault();
    }

    // Prevent entering 0 as the first digit
    if (event.key === '0' && currentValue === '') {
      event.preventDefault();
    }
  }

  onNotesChange(value: string) {
    if (value.length > 75) {
      alert('Maximum 75 characters allowed.');
      // Trim the value to 90 characters
      this.incudeNotesTitle = value.substring(0, 75);
    } else {
      this.incudeNotesTitle = value;
    }
  }

  onRevisionToggle() {
    if (!this.incudeRevisionhistory) {
      this.historyYear = null;
    }
  }
}
